export default __webpack_public_path__ + "static/media/3.d1427ed0.png";